import script from "./MintFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MintFooter.vue?vue&type=script&setup=true&lang=js"

import "./MintFooter.vue?vue&type=style&index=0&id=66d73197&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d73197"]])

export default __exports__